import { createRouter, createWebHistory } from 'vue-router';
import FrontLayout from '@/components/FrontLayout';
import DashboardLayout from '@/components/DashboardLayout';
import Invoice from "@/views/Panel/Invoice.vue";
import store from '@/store';
import axios from "@/plugins/axios";

const routes = [
  {
    path: '/',
    component: FrontLayout,
    children:[
      {
        path: '/',
        name: 'Index',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "index", webpackPrefetch: true */  '@/views/Front/Index.vue')
      },
      {
        path: '/page-detail/:slug',
        name: 'PageDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "page-detail" */ '@/views/Front/PageDetail.vue')
      },
      {
        path: '/product-list/:slug',
        name: 'ProductList',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "product-list", webpackPrefetch: true */ '@/views/Front/ProductList.vue')
      },
      {
        path: '/product-detail/:slug',
        name: 'ProductDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "product-detail", webpackPrefetch: true */ '@/views/Front/ProductDetail.vue')
      },
      {
        path: '/course-list/:slug',
        name: 'CourseList',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "course-list", webpackPrefetch: true */ '@/views/Front/CourseList.vue')
      },
      {
        path: '/article-list/:slug',
        name: 'ArticleList',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "article-list", webpackPrefetch: true */ '@/views/Front/ArticleList.vue')
      },
      {
        path: '/video-list/:slug',
        name: 'VideoList',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "video-list", webpackPrefetch: true */ '@/views/Front/VideoList.vue')
      },
      {
        path: '/course-detail/:slug',
        name: 'CourseDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "course-detail", webpackPrefetch: true */ '@/views/Front/CourseDetail.vue')
      },
      {
        path: '/article-detail/:slug',
        name: 'ArticleDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "article-detail" , webpackPrefetch: true*/ '@/views/Front/ArticleDetail.vue')
      },
      {
        path: '/video-detail/:slug',
        name: 'VideoDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "video-detail", webpackPrefetch: true */ '@/views/Front/VideoDetail.vue')
      },
      {
        path: '/basket',
        name: 'Basket',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "basket", webpackPrefetch: true */ '@/views/Front/Basket.vue')
      },
      {
        path: '/error/:code/:msg',
        name: 'HandleError',
        component: () => import(/* webpackChunkName: "error" */ '@/views/Front/HandleError.vue')
      },
      {
        path: '/login',
        name: 'Login',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Login.vue')
      },
      
      {
        path: '/register',
        name: 'Register',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "Register" */ '@/views/Auth/Register.vue')
      },
      {
        path: '/forgot-password',
        name: 'ForgotPassword',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "forgot-password" */ '@/views/Auth/ForgotPassword.vue')
      },
      {
        path: '/payment-alert',
        name: 'PaymentAlert',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "payment-alert" */ '@/views/Front/PaymentAlert.vue')
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "contact-us" */ '@/views/Front/ContactUs.vue')
      },
      {
        path: '/faq-categories',
        name: 'FaqCategory',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "faq-categories" */ '@/views/Front/FaqCategory.vue')
      },
      {
        path: '/faq-detail/:slug',
        name: 'FaqDetail',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "faq-detail" */ '@/views/Front/FaqDetail.vue')
      },
      {
        path: '/representative-request-form',
        name: 'RepresentativeRequestForm',
        // meta: { userShouldBeLogin: true },
        component: () => import(/* webpackChunkName: "faq-detail" */ '@/views/Front/RepresentativeRequestForm.vue')
      },
    ]
  },

  {
    path: '/dashboard',
    meta: {requiresAuth: true},
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Panel/Dashboard.vue')
      },
      {
        path: '/categories',
        name: 'Category',
        component: () => import(/* webpackChunkName: "categories" */ '@/views/Panel/Category.vue')
      },
      {
        path: '/roles',
        name: 'Role',
        component: () => import(/* webpackChunkName: "roles" */ '@/views/Panel/Role.vue')
      },
      {
        path: '/permissions',
        // meta: {hasProfile: store.state.user.has_profile},
        name: 'Permission',
        component: () => import(/* webpackChunkName: "permissions" */ '@/views/Panel/Permission.vue')
      },
      {
        path: '/users',
        name: 'User',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Panel/User.vue')
      },
      {
        path: '/marketing-roles',
        name: 'MarketingRole',
        component: () => import(/* webpackChunkName: "marketing-roles" */ '@/views/Panel/MarketingRole.vue')
      },
      {
        path: '/marketing-role-permissions',
        name: 'MarketingRolePermission',
        component: () => import(/* webpackChunkName: "marketing-role-permissions" */ '@/views/Panel/MarketingRolePermission.vue')
      },
      {
        path: '/marketing-connect-roles',
        name: 'MarketingConnectRole',
        component: () => import(/* webpackChunkName: "marketing-connect-roles" */ '@/views/Panel/MarketingConnectRole.vue')
      },
      {
        path: '/marketing-allowed-buy',
        name: 'MarketingAllowedBuy',
        component: () => import(/* webpackChunkName: "marketing-allowed-buy" */ '@/views/Panel/MarketingAllowedBuy.vue')
      },
      {
        path: '/marketing-colleagues',
        name: 'MarketingColleague',
        component: () => import(/* webpackChunkName: "marketing-colleagues" */ '@/views/Panel/MarketingColleague.vue')
      },
      {
        path: '/marketing-principal-agents-store',
        name: 'MarketingPrincipalAgentStore',
        component: () => import(/* webpackChunkName: "marketing-principal-agents-store" */ '@/views/Panel/PrincipalAgent/Store.vue')
      },
      {
        path: '/marketing-principal-agents-confirm',
        name: 'MarketingPrincipalAgentConfirm',
        component: () => import(/* webpackChunkName: "marketing-principal-agents-confirm" */ '@/views/Panel/PrincipalAgent/Confirm.vue')
      },
      {
        path: '/marketing-principal-agents-connect',
        name: 'MarketingPrincipalAgentConnect',
        component: () => import(/* webpackChunkName: "marketing-principal-agents-connect" */ '@/views/Panel/PrincipalAgent/Connect.vue')
      },
      {
        path: '/marketing-principal-agents-view',
        name: 'MarketingPrincipalAgentView',
        component: () => import(/* webpackChunkName: "marketing-principal-agents-view" */ '@/views/Panel/PrincipalAgent/View.vue')
      },
      
      {
        path: '/marketing-special',
        name: 'MarketingSpecial',
        component: () => import(/* webpackChunkName: "marketing-special" */ '@/views/Panel/MarketingSpecial.vue')
      },
      {
        path: '/marketing-roleRewards-penalties',
        name: 'MarketingRoleRewardsPenaltie',
        component: () => import(/* webpackChunkName: "marketing-roleRewards-penalties" */ '@/views/Panel/MarketingRoleRewardsPenaltie.vue')
      },
      {
        path: '/addresses',
        name: 'Address',
        component: () => import(/* webpackChunkName: "addresses" */ '@/views/Panel/Address.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Panel/Profile.vue')
      },
      {
        path: '/products',
        name: 'Product',
        component: () => import(/* webpackChunkName: "products" */ '@/views/Panel/Product.vue')
      },
      {
        path: '/marketing-role-course',
        name: 'MarketingRoleCourse',
        component: () => import(/* webpackChunkName: "marketing-role-course" */ '@/views/Panel/MarketingRoleCourse.vue')
      },
      {
        path: '/courses',
        name: 'Course',
        component: () => import(/* webpackChunkName: "courses" */ '@/views/Panel/Course.vue')
      },
      {
        path: '/course-repates',
        name: 'CourseRepate',
        component: () => import(/* webpackChunkName: "course-repates" */ '@/views/Panel/CourseRepate.vue')
      },
      {
        path: '/course-registers',
        name: 'CourseRegister',
        component: () => import(/* webpackChunkName: "course-registers" */ '@/views/Panel/CourseRegister.vue')
      },
      {
        path: '/stores',
        name: 'Store',
        component: () => import(/* webpackChunkName: "stores" */ '@/views/Panel/Store.vue')
      },
      {
        path: '/store-transactions',
        name: 'StoreTransaction',
        component: () => import(/* webpackChunkName: "store-transactions" */ '@/views/Panel/StoreTransaction.vue')
      },
      {
        path: '/store-histories',
        name: 'StoreHistory',
        component: () => import(/* webpackChunkName: "store-histories" */ '@/views/Panel/StoreHistory.vue')
      },
      {
        path: '/transport-types',
        name: 'TransportType',
        component: () => import(/* webpackChunkName: "transport-types" */ '@/views/Panel/TransportType.vue')
      },
      {
        path: '/transports',
        name: 'Transport',
        component: () => import(/* webpackChunkName: "transports" */ '@/views/Panel/Transport.vue')
      },
      {
        path: '/sliders',
        name: 'Slider',
        component: () => import(/* webpackChunkName: "sliders" */ '@/views/Panel/Slider.vue')
      },
      {
        path: '/articles',
        name: 'Article',
        component: () => import(/* webpackChunkName: "articles" */ '@/views/Panel/Article.vue')
      },
      {
        path: '/videos',
        name: 'Video',
        component: () => import(/* webpackChunkName: "videos" */ '@/views/Panel/Video.vue')
      },
      {
        path: '/brands',
        name: 'Brand',
        component: () => import(/* webpackChunkName: "brands" */ '@/views/Panel/Brand.vue')
      },
      {
        path: '/transactions',
        name: 'Transaction',
        component: () => import(/* webpackChunkName: "transactions" */ '@/views/Panel/Transaction.vue')
      },
      {
        path: '/withdrawals',
        name: 'Withdrawal',
        component: () => import(/* webpackChunkName: "withdrawals" */ '@/views/Panel/Withdrawal.vue')
      },
      {
        path: '/orders',
        name: 'Order',
        component: () => import(/* webpackChunkName: "orders" */ '@/views/Panel/Order.vue')
      },
      {
        path: '/order-detail/:order_id',
        name: 'OrderDetail',
        component: () => import(/* webpackChunkName: "order-detail" */ '@/views/Panel/OrderDetail.vue')
      },
      {
        path: '/marketing-histories',
        name: 'MarketingHistory',
        component: () => import(/* webpackChunkName: "marketing-histories" */ '@/views/Panel/MarketingHistory.vue')
      },
      {
        path: '/site-config',
        name: 'SiteConfig',
        component: () => import(/* webpackChunkName: "site-config" */ '@/views/Panel/SiteConfig.vue')
      },
      {
        path: '/login-histories',
        name: 'LoginHistory',
        component: () => import(/* webpackChunkName: "login-histories" */ '@/views/Panel/LoginHistory.vue')
      },
      
      {
        path: '/pages',
        name: 'Page',
        component: () => import(/* webpackChunkName: "pages" */ '@/views/Panel/Page.vue')
      },
      {
        path: '/contacts',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "contacts" */ '@/views/Panel/Contact.vue')
      },
      {
        path: '/faqs',
        name: 'Faq',
        component: () => import(/* webpackChunkName: "faqs" */ '@/views/Panel/Faq.vue')
      },
      {
        path: '/representative-requests',
        name: 'RepresentativeRequest',
        component: () => import(/* webpackChunkName: "RepresentativeRequest" */ '@/views/Panel/RepresentativeRequest.vue')
      },
      {
        path: '/product-questions',
        name: 'ProductQuestion',
        component: () => import(/* webpackChunkName: "product-questions" */ '@/views/Panel/ProductQuestion.vue')
      },
      {
        path: '/product-question-answers/:question_id',
        name: 'ProductQuestionAnswer',
        component: () => import(/* webpackChunkName: "product-question-answers" */ '@/views/Panel/ProductQuestionAnswer.vue')
      },
      {
        path: '/product-comments',
        name: 'ProductComment',
        component: () => import(/* webpackChunkName: "product-comments" */ '@/views/Panel/ProductComment.vue')
      },
      {
        path: '/promotion-demotions',
        name: 'PromotionDemotion',
        component: () => import(/* webpackChunkName: "promotion-demotions" */ '@/views/Panel/PromotionDemotion.vue')
      },
      {
        path: '/connect-user',
        name: 'ConnectUser',
        component: () => import(/* webpackChunkName: "connect-user" */ '@/views/Panel/ConnectUser.vue')
      },
      {
        path: '/report/user-sales',
        name: 'UserSales',
        component: () => import(/* webpackChunkName: "report/user-sales" */ '@/views/Panel/Report/UserSales.vue')
      },
      {
        path: '/report/product-sales',
        name: 'ProductSales',
        component: () => import(/* webpackChunkName: "report/product-sales" */ '@/views/Panel/Report/ProductSales.vue')
      },
      {
        path: '/report/invite',
        name: 'Invite',
        component: () => import(/* webpackChunkName: "report/invite" */ '@/views/Panel/Report/Invite.vue')
      },
      {
        path: '/report/wallet',
        name: 'Wallet',
        component: () => import(/* webpackChunkName: "report/wallet" */ '@/views/Panel/Report/Wallet.vue')
      },
      {
        path: '/gifts',
        name: 'Gift',
        component: () => import(/* webpackChunkName: "gifts" */ '@/views/Panel/Gift.vue')
      },
      // {
      //   path: '/payment-links',
      //   name: 'PaymentLink',
      //   component: () => import(/* webpackChunkName: "payment-links" */ '@/views/Panel/PaymentLink.vue')
      // },
    ]

  },

  {
    path: '/invoice/:order',
    meta: {requiresAuth: true},
    component: Invoice
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 };
  }
})

async function checkExpireCookie(){
  let expireAt = parseInt(store.getters.getCookie('expire_token'));
  let now = (new Date()).getTime();
  expireAt = isNaN(expireAt) ? now : expireAt;
  if(expireAt > now ){
    await store.dispatch('setCookie', 'expire_token')
  }else{
    store.commit('clearStorage')
  }
  // expireAt > now ? await store.dispatch('setCookie', 'expire_token') : store.commit('clearStorage')
}

router.beforeEach(async (to,from,next)=>{
  await checkExpireCookie();

  store.state.searchModal = false;
  store.state.searchText = '';
  store.state.showNav = false;
  store.state.toggleAside = false;
  store.state.showBasektPoup = false;

  if(!to.matched.length && to.fullPath !== '/'){
    next({name:'HandleError',params:{code:404,msg:'صفحه مورد نظر یافت نشد'}});
  }

  
  // if(to.meta.userShouldBeLogin && store.getters.getToken === null){
  //   next({name:'Login'});
  // }

  // if(to.meta.userShouldBeLogin && store.state.user.access !== 'agent'){
  //    next({name:'HandleError',params:{code:403,msg:'برای استفاده از سایت باید دسترسی نماینده داشته باشید.'}});
  // }

  if(to.meta.requiresAuth === true){
    store.dispatch('checkToken')
  }

  if(to.meta.requiresLogin && store.getters.getToken !== null){
    next({name:'Index'});
  }else if(to.meta.requiresAuth && !store.getters.getToken){
    next({name:'Index'});
  }else{
    next();
  }

});

export default router
